import React, { Component } from 'react';
import './App.css';
import Overlay from './components/OverlayZoom'
import styled from 'styled-components';
import questions from './data/questions'
import IntersectionVisible from './components/IntersectionVisible'
import images from './data/questions';

export const GoToViz = styled('span')`
  color: black;
  flex-basis: 100%;
  display: flex;
  margin-top: 2%;
  margin-bottom: 2%;
  justify-content: center;
  font-family: 'Roboto';
  text-decoration: none;
  &:active, &:hover, &:visited {
    color: black;
  }
  @media(min-width: 100px) {
    font-weight: 100;
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 0.7rem;
  }

  @media(min-width: 300px) {
    font-weight: 300;
    height: 1.9rem;
    line-height: 1.9rem;
    font-size: 1.0rem;
  }

  @media(min-width: 768px) {
    font-weight: 500;
    height: 2.4rem;
    line-height: 2.4rem;
    font-size: 1.2rem;
  }

  @media(min-width: 1024px) {
    font-weight: 700;
    height: 2.6rem;
    line-height: 2.6rem;
    font-size: 1.5rem;
`

export const TaggedKeyword = styled('a')`
    border-radius: 3px 0 0 3px;
    border: 1px solid black;
    color: black;
    &:active, &:hover, &:visited {
      color: black;
    }
    display: inline-block !important;
    //height: 50px;
    float: left;
    //line-height: 50px;
    padding: 0 30px 0 10px;
    font-family: 'Roboto';
    //font-weight: 700;
    position: relative;
    //font-size: 32px;
    margin: 0 6px 6px 3px;
    text-decoration: none;
    -webkit-transition: color 0.2s;

    @media(min-width: 100px) {
      font-weight: 100;
      height: 1.5rem;
      line-height: 1.5rem;
      font-size: 0.7rem;
    }

    @media(min-width: 300px) {
      font-weight: 300;
      height: 1.9rem;
      line-height: 1.9rem;
      font-size: 1.0rem;
    }

    @media(min-width: 768px) {
      font-weight: 500;
      height: 2.4rem;
      line-height: 2.4rem;
      font-size: 1.2rem;
    }

    @media(min-width: 1024px) {
      font-weight: 700;
      height: 2.6rem;
      line-height: 2.6rem;
      font-size: 1.5rem;
    }
`
export const Replies = styled('div')`
  padding-left: 1vw;
  padding-top: 1vh;
`

export const UntaggedKeyword = styled('a')`
    //background: #85c8ea;
    border-radius: 3px 0 0 3px;
    border: 1px solid grey;
    font-family: 'Roboto';
    color: grey;
    &:active, &:hover, &:visited {
      color: grey;
    }
    //color: #fff !important;
    display: inline-block !important;
    //height: 50px;
    float: left;
    //line-height: 50px;
    padding: 0 30px 0 10px;
    position: relative;
    //font-family: sans-serif;
    //font-size: 32px;
    //font-weight: 700;
    //color: black;
    margin: 0 6px 6px 3px;
    text-decoration: none;
    -webkit-transition: color 0.2s;

    @media(min-width: 100px) {
      font-weight: 100;
      height: 1.5rem;
      line-height: 1.5rem;
      font-size: 0.7rem;
    }

    @media(min-width: 350px) {
      font-weight: 300;
      height: 1.9rem;
      line-height: 1.9rem;
      font-size: 1.0rem;
    }

    @media(min-width: 768px) {
      font-weight: 500;
      height: 2.4rem;
      line-height: 2.4rem;
      font-size: 1.2rem;
    }

    @media(min-width: 1024px) {
      font-weight: 700;
      height: 2.6rem;
      line-height: 2.6rem;
      font-size: 1.5rem;
    }
`

export const Life = styled('div')`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  --width: 500px;
  text-align: left;
  top: 0px;
  --transform: translateY(-50%);
  --background-color: green;
  color: black;
  font-family: 'Roboto';
  font-size: 20px;
  // font-style: normal;
  // font-weight: 400;
  // font-size: 40px;
  display: flex;
  margin-bottom: 50px;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    --font: 100 50px/1.1 'Roboto', sans-serif;
`

export const ButtonDiv = styled('span')`
  text-align: center;
  --transform: translateY(-50%);
  --background: red;
  color: black;
  font-family: 'Roboto';
  font-size: 32px;
  cursor: pointer;
  padding: 10px;
    --font: 100 50px/1.1 'Roboto', sans-serif;
`

export const Img = styled('img')`
  width: 100%;
`

const width = 1000;

const footer = <div>
  {/*<Button label="Save" icon="pi pi-check" style={{marginRight: '.25em'}}/>
                <Button label="Cancel" icon="pi pi-times" className="p-button-secondary"/> */}
  <ButtonDiv onClick={() => this.sendReply(true)}>
    [YES]
            </ButtonDiv>
  <ButtonDiv onClick={() => this.sendReply(false)}>
    [NO]
            </ButtonDiv>
</div>;

export const Keywords = props => {
  const {reply, yes, no} = props;
  return (
    <span>
    {reply && yes.map(k => <TaggedKeyword><nobr>{k}</nobr></TaggedKeyword>)}
    {reply && no.map(k => <UntaggedKeyword><nobr>{k}</nobr></UntaggedKeyword>)}
    {!reply && no.map(k => <TaggedKeyword><nobr>{k}</nobr></TaggedKeyword>)}
    {!reply && yes.map(k => <UntaggedKeyword><nobr>{k}</nobr></UntaggedKeyword>)}
    </span>
  )
}


export const Thanks = props => {
  return <div>
    <GoToViz>
      <a href="../viz/index.html">Go to visualization</a>
    </GoToViz>
    {props.children}
  </div>
}

export default class Home extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

  sendReply = (v) => {
    console.log('replied ===' + v)
    const { questions, currentQuestion } = this.state;
    questions[currentQuestion].answered = true;
    this.setState(state => ({
      ...state, questions: questions,
      fullScreen: !state.fullScreen,
      currentQuestion: currentQuestion == questions.length-1? 0: currentQuestion + 1,
      replies: [...state.replies, { question: state.currentQuestion, reply: v }]
    }));
    console.log(this.state.replies);
    //this.myRef.current.scrollTo(0, 0);
  };

  componentDidMount() {
    images.forEach((image) => {
        new Image().src = image
    });
  }

  componentDidUpdate() {
    window.scrollTo(0, 0);
  }

  state = {
    viewport: {
      width: 1000,
      height: 900,
      latitude: 37.7577,
      longitude: -122.4376,
      zoom: 0
    },
    fullScreen: false, replies: [], currentQuestion: 0, questions
  };

  myRef = React.createRef()

  showQuestion = (index) => {
    // const {popup} = this.state;
    // console.log('show question:' + this.state.fullScreen + "|" + index)
    if (window.pageYOffset > 0){
      setTimeout( () => {
        this.setState(state => ({ ...state, fullScreen: !state.fullScreen, currentQuestion: index }));
      }, 750);
      
    }
  }
  
  hideQuestion = () => {
    // const {popup} = this.state;
    // console.log('show question:' + this.state.fullScreen + "|" + index)
    if (this.state.fullScreen)
      this.setState(state => ({ ...state, fullScreen: false }));
  }

  

  render() {
    const { questions, currentQuestion, replies } = this.state;
    let reply = false;
    let fakeReplies= [{"question":0, "reply": true}, {"question": 1, "reply": false}, {"question": 2, "reply": false}
    , {"question": 3, "reply": false}, {"question": 4, "reply": false}, {"question": 5, "reply": false}
    , {"question": 6, "reply": false}, {"question": 7, "reply": false}, {"question": 8, "reply": false}];
    return (
      <div className="Home" ref={this.myRef}>
        {!questions[currentQuestion].answered && !this.state.fullScreen && questions[currentQuestion].images.map(img => {
          return (
             <Img src={img} />
          )
        })}
        {!questions[currentQuestion].answered && <span>not</span>}
        {!questions[currentQuestion].answered && 
          <IntersectionVisible
                onIntersect={(entries) => console.log(entries)}
                onShow={() => this.showQuestion(currentQuestion)}
                onHide={() => () => {}}
                className="element"
              >
              <Overlay fullScreen={this.state.fullScreen}
              currentQuestion={questions[currentQuestion]} sendReply={this.sendReply.bind(this)} />
        </IntersectionVisible>
        }
        <Replies>
        {questions[currentQuestion].answered && replies && <Thanks>{
          replies.map(r => <Keywords yes={questions[r.question]['yes']} no={questions[r.question]['no']} reply={r.reply} />)
        }</Thanks>
        }
        </Replies>
      </div>
    );
  }
}